import React from 'react';
import { withStyles } from 'tss-react/mui';
import { SlidesListView } from 'components/SlidesList/SlidesListView';
import { MiniDrawerWithContext } from 'components/Layout/drawer';

const styles = () => ({
  root: {
    height: '85vh',
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
});

export const _SlidesListGridPage = ({ classes }) => (
  <MiniDrawerWithContext header={'Slides List'}>
    <div className={classes.root}>
      <SlidesListView />
    </div>
  </MiniDrawerWithContext>
);

export const SlidesListPage = withStyles(_SlidesListGridPage, styles);
